import { useState } from "react";

/**
 * Shared filter state for admin dashboard tabs (view, scope, date range, plan type, rank sort).
 */
export default function useDashboardFilters() {
  const [activeTab, setActiveTab] = useState("Overview");
  const [timeFrame, setTimeFrame] = useState("W");
  const [scope, setScope] = useState("both");
  const [planType, setPlanType] = useState("customized");
  const [filters, setFilters] = useState({ startDate: null, endDate: null });
  const [localFilters, setLocalFilters] = useState({
    agents: "Revenue",
  });

  return {
    activeTab,
    setActiveTab,
    timeFrame,
    setTimeFrame,
    scope,
    setScope,
    planType,
    setPlanType,
    filters,
    setFilters,
    localFilters,
    setLocalFilters,
  };
}